import TextArea from "antd/lib/input/TextArea";
import React, { ChangeEventHandler } from "react";
import "../css/components.css";

type GenericTextAreaProps = {
  handleOnChange: ChangeEventHandler<HTMLTextAreaElement>;
  text: string;
  name: string;
  error: boolean;
};

function GenericTextArea({
  text,
  handleOnChange,
  name,
  error,
}: GenericTextAreaProps) {
  return (
    <div className="generic_textAreafield_container">
      <TextArea
        name={name}
        value={text}
        onChange={handleOnChange}
        style={{ height: 120, resize: "none" }}
        status={error ? "error" : ""}
        maxLength={400}
      />
    </div>
  );
}

export default GenericTextArea;
